// Progress tracking per candidate
const KEY = 'ic_progress';

export function loadProgress() {
  try { const v = localStorage.getItem(KEY); return v ? JSON.parse(v) : {}; }
  catch { return {}; }
}

export function saveProgress(data) {
  try { localStorage.setItem(KEY, JSON.stringify(data)); } catch {}
}

export function recordEssayResult(email, essayType, promptTitle, bandScores) {
  const all = loadProgress();
  if (!all[email]) all[email] = { essays: [] };
  all[email].essays.push({
    id: Date.now(),
    date: new Date().toLocaleDateString('en-GB'),
    essayType,
    promptTitle,
    bands: bandScores, // { intro, body1, body2, conclusion }
    overall: average(Object.values(bandScores).filter(Boolean).map(Number))
  });
  saveProgress(all);
}

export function getCandidateProgress(email) {
  const all = loadProgress();
  return all[email] || { essays: [] };
}

function average(arr) {
  if (!arr.length) return 0;
  return Math.round((arr.reduce((a,b)=>a+b,0) / arr.length) * 2) / 2;
}
